var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159,
    height: 59,
    viewBox: "0 0 159 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M92.072 15.053c0 8.308-6.66 15.022-14.901 15.022S62.27 23.361 62.27 15.053C62.27 6.744 68.93.03 77.171.03s14.984 6.714 14.901 15.023zm-3.496 0c0-6.379-5.078-11.498-11.405-11.498-6.327 0-11.405 5.12-11.405 11.498 0 6.378 5.162 11.498 11.405 11.498 6.327 0 11.405-5.12 11.405-11.498z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M14.901 26.55c-6.327 0-11.405-5.119-11.405-11.497 0-6.379 5.078-11.498 11.405-11.498 3.163 0 5.994 1.259 8.075 3.357l2.497-2.518C22.81 1.71 19.063.03 14.901.03 6.66.03 0 6.744 0 15.053c0 8.308 6.66 15.022 14.901 15.022 4.162 0 7.825-1.678 10.572-4.448l-2.497-2.517c-2.081 2.182-4.912 3.44-8.075 3.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M123.201 26.55c-6.243 0-11.405-5.119-11.405-11.497 0-6.379 5.078-11.498 11.405-11.498 3.163 0 5.994 1.259 8.075 3.357l2.497-2.518C131.026 1.71 127.363.03 123.201.03 114.96.03 108.3 6.744 108.3 15.053c0 8.308 6.66 15.022 14.901 15.022 4.162 0 7.825-1.678 10.572-4.448l-2.497-2.517c-2.081 2.182-4.912 3.44-8.075 3.44z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M35.3.86h-3.58v28.535h3.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M101.98 10.35H98.4v18.967h3.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M56.19.86h-3.58v28.535h3.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M54.445 13.29H33.55v3.609h20.895z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M143.85.86h-3.58v28.535h3.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M159.082 13.29H142.1v3.609h16.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M159.082 25.79H142.1v3.609h16.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M159.082.86H142.1v3.609h16.982z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M100.227 6.573L94.15.53h12.07z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M54.11 55.25c0 2.433-1.5 3.776-3.58 3.776-2.082 0-3.58-1.343-3.58-3.777V49.71h1.082v5.54c0 1.845 1.166 2.685 2.498 2.685 1.415 0 2.497-.84 2.497-2.686V49.71h1.082z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M58.77 58.858h1.082V49.71H58.77zm2.58-4.868l4.08-4.196h-1.332l-4.08 4.196 4.496 4.868h1.332z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M75.667 58.858l-2.83-3.86h-1.915v3.86H69.84V49.71h3.163c1.749 0 2.914 1.091 2.914 2.602 0 1.259-.75 2.182-1.915 2.517l2.914 3.945h-1.249zm-4.745-4.784h2.081c1.166 0 1.832-.671 1.832-1.678s-.666-1.679-1.832-1.679h-2.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M86.247 57.01h-4.412l-.75 1.846H79.92l3.913-9.316h.416l3.912 9.316h-1.165zm-2.248-5.456l-1.831 4.532h3.662z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M93.232 58.858H92.15V49.71h1.082z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M105.222 49.708v9.316h-.416l-5.744-6.966v6.882H97.98v-9.4h.416l5.744 7.05v-6.882z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M115.877 50.717h-4.745v2.77h3.663v1.007h-3.663v3.44h4.912v1.008h-5.994V49.71h5.827z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.d4e216cae5bb0fd26226a5623986bf81.svg";
export { ForwardRef as ReactComponent };